/**
 * `Idempotency-Key` for distribution writes. api-service applies a write once per key, so one user
 * action = one key, and a retry of that action re-sends the same key.
 */
import type { RequestOptions } from "../api";

/** A v4 UUID for `Idempotency-Key`; `crypto.randomUUID` where the browser has it. */
export const newIdempotencyKey = (): string => {
  const cryptoApi = globalThis.crypto;
  if (typeof cryptoApi?.randomUUID === "function") return cryptoApi.randomUUID();
  const bytes = new Uint8Array(16);
  if (typeof cryptoApi?.getRandomValues === "function") cryptoApi.getRandomValues(bytes);
  else bytes.forEach((_, i) => (bytes[i] = Math.floor(Math.random() * 256)));
  bytes[6] = (bytes[6] & 0x0f) | 0x40;
  bytes[8] = (bytes[8] & 0x3f) | 0x80;
  const hex = Array.from(bytes, (b) => b.toString(16).padStart(2, "0")).join("");
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
};

/**
 * Options for a distribution write. api-service applies a write once per key, so a retry of the
 * same user action must pass the same key (useDistributionWrite does); a new action gets a new one.
 */
export const writeOptions = (idempotencyKey: string, params?: object): RequestOptions => ({
  headers: { "Idempotency-Key": idempotencyKey },
  ...(params ? { params } : {}),
});
